module.exports = __webpack_public_path__ + "static/media/campaign-thumbnail-ransomware.2bb29380.png";